import React, { useState, useEffect } from 'react';
import { useLanguage } from '../../../context/language/LanguageContext';
import { bannerData } from '../../../utils/homeData';
import './Banner.css';

const Banner = () => {
    const { language } = useLanguage();
    const [currentPhotoIndex, setCurrentPhotoIndex] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentPhotoIndex((prev) => (prev + 1) % bannerData.photos.length);
        }, 15000);
        return () => clearInterval(interval);
    }, []);

    return (
        <div className="banner-section">
            {/* Photo Section */}
            <div className="photo-container">
                <img
                    src={bannerData.photos[currentPhotoIndex]}
                    alt={bannerData[language].description}
                    className="banner-photo"
                />
                <div className="banner-description">
                    {bannerData[language].description.map((line, index) => (
                        <h1 key={index}>{line}</h1>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Banner;